import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { zustandDrugSearchHistoryStorageName } from 'src/utils/cookieHelper';
import useStore from './useStore';

interface State {
  addSearchValuesToHistory: (value: string) => void;
  searchHistoryList: string[];
}

const useSearchHistoryStore = create<State>()(
  persist(
    (set) => ({
      addSearchValuesToHistory: (value: string) =>
        set((state) => {
          const parsedList = state.searchHistoryList;
          // check if id has been saved already
          if (!parsedList?.includes(value)) {
            // save only 5 last viewed drugs
            if (parsedList?.length >= 5) {
              parsedList.shift();
            }
            parsedList.push(value);
          }
          return { searchHistoryList: parsedList };
        }),
      searchHistoryList: []
    }),
    {
      name: zustandDrugSearchHistoryStorageName
    }
  )
);

const fallbackStore: State = {
  addSearchValuesToHistory: null,
  searchHistoryList: []
};

export default () =>
  useStore<State>(useSearchHistoryStore, (state) => state) ?? fallbackStore;
